var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../../service/api.service';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
import { ColumnService } from '../../../../items/columns/column/column.service';
var KtsConstructionTypeService = /** @class */ (function (_super) {
    __extends(KtsConstructionTypeService, _super);
    function KtsConstructionTypeService(logger, api, colservice) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.colservice = colservice;
        return _this;
    }
    KtsConstructionTypeService.prototype.checkItem = function (rec) {
        var construction_type = rec.construction_type;
        var construction_middle_classification_id = rec.construction_middle_classification_id;
        var check = true;
        if (construction_type === 'expand' && !this.colservice.checkVal(construction_middle_classification_id)) {
            check = false;
        }
        return check;
    };
    KtsConstructionTypeService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    KtsConstructionTypeService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnService }
    ]; };
    return KtsConstructionTypeService;
}(ContentBaseService));
export { KtsConstructionTypeService };
var ConstructionTypeTemplate = /** @class */ (function () {
    function ConstructionTypeTemplate() {
    }
    return ConstructionTypeTemplate;
}());
export { ConstructionTypeTemplate };
//# sourceMappingURL=construction-type.service.js.map